import React, { useEffect, useMemo } from "react";
import { PageNotFound, NOT_FOUND, REMOVED_GIF } from "components/page-not-found/PageNotFound";
import { useGifQuery } from "queries";
import { RelatedFeed } from "./RelatedFeed";
import { PlayerPlaceholder } from "components/UI/Skeleton";
import { PreviewFeed } from "components/feed/PreviewFeed";

import "./WatchFeed.scss";

const STATUS_OK = 200;
const STATUS_GONE = 410;
const STATUS_NOT_FOUND = 404;

export const WatchFeed = (props: {
  gif: string;
  rel?: string;
  order?: string;
  verified: boolean;
}) => {
  const { data, isLoading, error } = useGifQuery(props.gif);

  const responseStatus = useMemo(() => {
    if (error !== null && (error.response?.status === STATUS_GONE || error.response?.status === STATUS_NOT_FOUND)) {
      return error.response.status;
    }

    return STATUS_OK;
  }, [error]);

  /**
   * Pull information about the author of the gif.
   */
  useEffect(() => {
    if (data) {
      const g = data.gif;
      const u = g.userName;
      const t = g.tags;
      const type = g.type === 2 ? "Pic" : "Gif";

      if (t.length && u) {
        document.title = `${t.join(" ")} Porn ${type} by ${u} | RedGIFs`;
      } else if (g.tags.length && !g.userName) {
        document.title = `${t.join(" ")} Porn ${type} | RedGIFs`;
      } else if (!t.length && u) {
        document.title = `Porn ${type} | RedGIFs`;
      } else {
        document.title = "RedGIFs | Best Porn GIFs and Pics";
      }
    }
  }, [data]);

  return (
    <div className="watchFeed center">
      {isLoading && <PreviewFeed><PlayerPlaceholder /></PreviewFeed>}
      {!isLoading && responseStatus === STATUS_NOT_FOUND && <PageNotFound pageType={NOT_FOUND} />}
      {!isLoading && responseStatus === STATUS_GONE && <PageNotFound pageType={REMOVED_GIF} />}
      {!isLoading && responseStatus === STATUS_OK && data?.gif && (
        <RelatedFeed
          gif={data.gif}
          user={data.user}
          niches={data.niches}
          rel={props.rel}
          order={props.order}
          verified={props.verified}
        />
      )}
    </div>
  );
};
